<template>
  <div>
    <div
      v-for="(item, index) in data.accordions"
      :key="index"
      class="border-b border-neutral-300"
      :class="data.primary ? 'py-3 first:border-t' : 'mb-3 py-5 last:mb-0'"
      :tabindex="index"
    >
      <div
        class="flex cursor-pointer items-center justify-between text-xl"
        @click="expandAccordion(index)"
      >
        <span :class="!data.primary ? 'font-bold uppercase' : ''">{{ item.title }}</span>
        <Icon
          :name="data.primary ? 'chevron-down' : getIconName(activeIndex === index)"
          class="transition-all duration-300"
          :class="activeIndex === index && 'rotate-180'"
          :color="activeIndex === index ? theme.colors.teal[500] : theme.colors.neutral[800]"
        />
      </div>

      <div
        class="grid transform-gpu transition-all duration-500"
        :class="
          activeIndex === index ? 'opacity-1 mt-1 grid-rows-[1fr]' : 'grid-rows-[0fr] opacity-0'
        "
      >
        <div class="prose overflow-hidden text-base lg:text-xl">
          <div v-html="item.body"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AccordionListRecord } from '~/types/generated'
import { theme } from '#tailwind-config'

defineProps({
  data: {
    type: Object as PropType<AccordionListRecord>,
    default: () => {}
  }
})
const activeIndex = ref<number | null>(null)

function getIconName(isActive: boolean) {
  return isActive ? 'minus' : 'plus'
}

function expandAccordion(idx: number) {
  activeIndex.value = activeIndex.value !== idx ? idx : null
}
</script>
